import { cleanString, numberOrNull } from './helpers';

/* ============================================================
   ADDRESS - FRONTEND -> BACKEND
============================================================ */

export function transformAddress(address = {}) {
    const geo = address.geo || {};

    const coordinates = Array.isArray(geo.coordinates)
        ? geo.coordinates.map((value) => numberOrNull(value)).filter((value) => value !== null)
        : [];

    return {
        line1: cleanString(address.line1 || address.addressLine1),

        line2: cleanString(address.line2 || address.addressLine2),

        landmark: cleanString(address.landmark),

        locality: cleanString(address.locality || address.area),

        city: cleanString(address.city),

        district: cleanString(address.district),

        state: cleanString(address.state),

        country: cleanString(address.country) || 'India',

        countryCode: cleanString(address.countryCode) || 'IN',

        pincode: cleanString(address.pincode || address.zipCode || address.postalCode),

        geo: {
            type: 'Point',

            coordinates: coordinates.length === 2 ? coordinates : [0, 0]
        }
    };
}

/* ============================================================
   ADDRESS - BACKEND -> FRONTEND
   ------------------------------------------------------------
   The Location step only reads/writes line1, line2, landmark,
   city, state, country, pincode and geo. locality/district/
   countryCode exist on the backend but have no field in the
   Location step UI, so they're kept on the object (in case
   something else reads them) but nothing is lost - they just
   round-trip untouched.
============================================================ */

export function reverseAddress(address = {}) {
    const geo = address?.geo || {};

    const coordinates = Array.isArray(geo.coordinates) && geo.coordinates.length === 2 ? geo.coordinates : [0, 0];

    return {
        line1: cleanString(address.line1),
        line2: cleanString(address.line2),
        landmark: cleanString(address.landmark),
        locality: cleanString(address.locality),
        city: cleanString(address.city),
        district: cleanString(address.district),
        state: cleanString(address.state),
        country: cleanString(address.country) || 'India',
        countryCode: cleanString(address.countryCode) || 'IN',
        pincode: cleanString(address.pincode),

        geo: {
            type: 'Point',
            coordinates
        }
    };
}
